module.exports = __webpack_public_path__ + "media/images/diy/logo_2-27944b982253a1700d432101ef19e07e.png";